import { call, put, takeLatest } from "redux-saga/effects";
import { sagaActions } from "./sagaActions";
import { callGetAPI } from "../API";
import { SERVER_API } from "../../helper/Constants";

function* fetchHomeLookups() {
  try {
    const homeLookups = yield call(() => callGetAPI(SERVER_API.HOME_LOOKUPS));
    yield put({ type: sagaActions.HOME_LOOKUPS_LOAD, data: homeLookups.data });
  } catch (e) {
    yield put({ type: sagaActions.API_FAILED, message: e.message });
  }
}

function* watchFetchHomeLookupsAsync() {
  yield takeLatest(sagaActions.HOME_LOOKUPS_LOAD_REQUEST, fetchHomeLookups);
}

export default watchFetchHomeLookupsAsync;
